import React from 'react';
const ResumeUpload = React.lazy(() => import('../components/resumeUpload'));

const partners = {
  shine_: {
    logo: {
      default: 'https://www.shine.com/next/static/images/shine-logo.png',
      alt: 'shineLogoAlt',
    },

    name: 'Shine',
    title: 'Upload your old resume - Shine.com',
    description:
      'Upload your current resume and our AI will analyze it and provide you an optimized resume.',
    url: 'https://www.shine.com/',
    theme: {
      palette: {
        primary: { main: '#193367', contrastText: '#fff' },
        secondary: { main: '#ffcb00' },
        background: { paper: '#e8edf6' },
        text: { contrastText: '#F6CAC8' },
        secondary: {
          main: '#ffcb00',
        },
      },
      typography: {
        fontFamily: [
          'PT Sans',
          '"sans-serif"',
          '"system-ui"',
          '"Segoe UI"',
          'Roboto',
          '"Helvetica Neue"',
          'Arial',
          'sans-serif',
          '"Apple Color Emoji"',
          '"Segoe UI Emoji"',
          '"Segoe UI Symbol"',
        ].join(','),
      },
    },
    routes: {
      Dashboard: ResumeUpload,
    },
    apiKey: {
      development:
        'f7fd9b3df179da5911914d04440cec96df47949d272ec14b72cf419e4ac03e34',
      staging:
        'f7fd9b3df179da5911914d04440cec96df47949d272ec14b72cf419e4ac03e34',
      production:
        '78c26902587eb6ca44eb1ccc53a069c8263580229eb9e5d8d5cb40f9e33a9db9',
    },
    tenantId: {
      development: 'nsMxI0q4qVXjNYLmjvfl',
      staging: 'nsMxI0q4qVXjNYLmjvfl',
      production: 'lr1KMT2zlcgqwdFLW3tn',
    },
    gaTrackingKey: 'G-84QKYN9N90',
    gaEnabled: true,
    partnerId: 'shine',
    builderFeatures: {
      enableAiFeatures: false,
      enableTemplateSelection: true,
    },
    templates: [
      {
        colors: ['#193367', '#ffe14c', '#91d9e2', '#f6afad', '#ff9837'],
        accessor: 'MadridShineResume',
        key: 'sunShine',
        name: 'Sun Shine',
        templateDescription:
          'Effortlessly customize this simple resume format in less than ten minutes using our user-friendly system for personalization.',
        category: [],
        previewUrl: {
          default: '/template-preview/200kb/SunPreview_200kb.png',
          lowRes: '/template-preview/30kb/SunPreview_30kb.webp',
          highRes: '/template-preview/100kb/SunPreview_100kb.png',
        },
        enableCustomFont: false,
        fonts: [
          'Default',
          'Lato',
          'Helvetica',
          'Times-Roman',
          'Courier',
          'Roboto',
          'SourceSansPro',
        ],
        sectionPositioning: false,
        enableDnd: false,
        heading: 'Simple resume template',
        altText: 'Instaresume Resume Template: Free simple resume template',
        skillDescription: false,
      },
      {
        colors: ['#1D473A', '#082A4D', '#581010', '#32084D', '#1B212F'],
        accessor: 'DublinResume',
        key: 'forest',
        name: 'Forest',
        templateDescription:
          'Selecting an IT-focused layout is optimal when aiming to highlight your expertise in your resume.',
        category: [],
        previewUrl: {
          default: '/template-preview/200kb/ForestPreview_200kb.png',
          lowRes: '/template-preview/30kb/ForestPreview_30kb.webp',
          highRes: '/template-preview/100kb/ForestPreview_100kb.png',
        },
        enableCustomFont: false,
        fonts: [
          'Default',
          'Lato',
          'Helvetica',
          'Times-Roman',
          'Courier',
          'Roboto',
          'SourceSansPro',
        ],
        sectionPositioning: false,
        enableDnd: false,
        heading: 'Two Column Resume Template With Side Bar Left',
        altText: 'Instaresume Resume Template: Two column resume template',
      },
      {
        accessor: 'AdvanceResume',
        colors: ['#082A4D', '#581010', '#1D473A', '#32084D', '#1B212F'],
        key: 'ocean',
        name: 'Ocean',
        templateDescription:
          'A clear layout prioritizing skills and work experience, ensuring equal importance across all resume sections.',
        category: [],
        previewUrl: {
          default: '/template-preview/200kb/OceanPreview_200kb.png',
          lowRes: '/template-preview/30kb/OceanPreview_30kb.webp',
          highRes: '/template-preview/100kb/OceanPreview_100kb.png',
        },
        enableCustomFont: false,
        fonts: [
          'Default',
          'Lato',
          'Helvetica',
          'Times-Roman',
          'Courier',
          'Roboto',
          'SourceSansPro',
        ],
        sectionPositioning: true,
        enableDnd: true,
        defaultSectionPosition: {
          courses: 'right',
          workExperiences: 'left',
          educations: 'left',
          skills: 'right',
          internships: 'left',
          activities: 'left',
          hobbies: 'right',
          languages: 'right',
          references: 'right',
          links: 'right',
          customSections: 'left',
        },
        heading: 'Two column Cv Template with side bar right',
        altText: 'Instaresume Resume Template: Two column cv template',
      },

      {
        colors: ['#a3160f', '#082A4D', '#581010', '#32084D', '#1B212F'],
        accessor: 'BasicResume',
        key: 'fire',
        name: 'Fire',
        templateDescription:
          'Streamlined resume template ideal for conservative industries that value simplicity over flashy designs.',
        category: [],
        previewUrl: {
          default: '/template-preview/200kb/FirePreview_200kb.png',
          lowRes: '/template-preview/30kb/FirePreview_30kb.webp',
          highRes: '/template-preview/100kb/FirePreview_100kb.png',
        },
        enableCustomFont: false,
        fonts: [
          'Default',
          'Lato',
          'Helvetica',
          'Times-Roman',
          'Courier',
          'Roboto',
          'SourceSansPro',
        ],
        sectionPositioning: false,
        enableDnd: false,
        heading: 'College resume template',
        altText: 'Instaresume Resume Template: College resume template',
      },
      {
        colors: ['#4BFBBA', '#FEF66D', '#9AEBFD', '#FED68C', '#E4E4E4'],
        accessor: 'ViennaResume',
        key: 'breeze',
        name: 'Breeze',
        templateDescription:
          'Customize this general template to match your personality and skills when seeking employment across various industries.',
        category: [],
        previewUrl: {
          default: '/template-preview/200kb/BreezePreview_200kb.png',
          lowRes: '/template-preview/30kb/BreezePreview_30kb.webp',
          highRes: '/template-preview/100kb/BreezePreview_100kb.png',
        },
        enableCustomFont: false,
        fonts: [
          'Default',
          'Lato',
          'Helvetica',
          'Times-Roman',
          'Courier',
          'Roboto',
          'SourceSansPro',
        ],
        sectionPositioning: false,
        enableDnd: false,
        heading: 'Minimalistic Resume Template',
        altText: 'Instaresume Resume Template: Minimalist resume template',
      },
      {
        colors: ['#0a3545', '#45350a', '#1E0A45', '#380a45', '#450a2b'],
        accessor: 'KolkataResume',
        key: 'tree',
        name: 'Tree',
        templateDescription:
          'Integrating two resume styles, this template merges the reverse-chronological and functional formats for a professional and versatile approach.',
        category: [],
        previewUrl: {
          default: '/template-preview/200kb/TreePreview_200kb.png',
          lowRes: '/template-preview/30kb/TreePreview_30kb.webp',
          highRes: '/template-preview/100kb/TreePreview_100kb.png',
        },
        enableCustomFont: false,
        fonts: [
          'Default',
          'Lato',
          'Helvetica',
          'Times-Roman',
          'Courier',
          'Roboto',
          'SourceSansPro',
        ],
        sectionPositioning: false,
        enableDnd: false,
        heading: 'Creative two column resume template',
        altText:
          'Instaresume Resume Template: Creative two column resume template',
      },
      {
        colors: ['#455aa3', '#305072', '#45a385', '#30725d', '#000'],
        accessor: 'WaterResume',
        key: 'water',
        name: 'Water',
        templateDescription:
          'An endorsed resume example by recruiters, aiding many in securing their dream job, sets a professional standard.',
        category: [],
        previewUrl: {
          default: '/template-preview/200kb/WaterPreview_200kb.png',
          lowRes: '/template-preview/30kb/WaterPreview_30kb.webp',
          highRes: '/template-preview/100kb/WaterPreview_100kb.png',
        },
        enableCustomFont: false,
        fonts: [
          'Default',
          'Lato',
          'Helvetica',
          'Times-Roman',
          'Courier',
          'Roboto',
          'SourceSansPro',
        ],
        sectionPositioning: false,
        enableDnd: false,
        heading: 'Modern Resume template',
        altText: 'Instaresume Resume Template: Modern resume template',
      },
      {
        colors: ['#F1F9FE', '#f2f3fe', '#f2f3fe', '#fefcf1', '#fef1f8'],
        accessor: 'IceResume',
        key: 'ice',
        name: 'Ice',
        templateDescription:
          'A modernized college resume template for the 21st century, offering an alternative to traditional formats while staying contemporary.',
        category: [],
        previewUrl: {
          default: '/template-preview/200kb/IcePreview_200kb.png',
          lowRes: '/template-preview/30kb/IcePreview_30kb.webp',
          highRes: '/template-preview/100kb/IcePreview_100kb.png',
        },
        enableCustomFont: false,
        fonts: [
          'Default',
          'Lato',
          'Helvetica',
          'Times-Roman',
          'Courier',
          'Roboto',
          'SourceSansPro',
        ],
        sectionPositioning: false,
        enableDnd: false,
        heading: 'Classic resume template',
        altText: 'Instaresume Resume Template: Multi column resume',
      },
      {
        colors: ['#F1F9FE', '#f2f3fe', '#f2f3fe', '#fefcf1', '#fef1f8'],
        accessor: 'KashmirResume',
        key: 'sky',
        name: 'Sky',
        templateDescription:
          'Secure your dream position in the creative field with this standout resume template tailored for the creative industries.',
        category: [],
        previewUrl: {
          default: '/template-preview/200kb/SkyPreview_200kb.png',
          lowRes: '/template-preview/30kb/SkyPreview_30kb.webp',
          highRes: '/template-preview/100kb/SkyPreview_100kb.png',
        },
        enableCustomFont: false,
        fonts: [
          'Default',
          'Lato',
          'Helvetica',
          'Times-Roman',
          'Courier',
          'Roboto',
          'SourceSansPro',
        ],
        sectionPositioning: false,
        enableDnd: false,
        heading: 'Creative Resume template',
        altText: 'Instaresume Resume Template: Creative resume template',
      },
      {
        colors: ['#000', '#082A4D', '#581010', '#32084D', '#1B212F'],
        accessor: 'CloudResume',
        key: 'cloud',
        name: 'Cloud',
        templateDescription:
          'The template combines functional and reverse-chronological elements, emphasizing both skills and experiences in its structure.',
        category: [],
        previewUrl: {
          default: '/template-preview/200kb/CloudPreview_200kb.png',
          lowRes: '/template-preview/30kb/CloudPreview_30kb.webp',
          highRes: '/template-preview/100kb/CloudPreview_100kb.png',
        },
        enableCustomFont: false,
        fonts: [
          'Default',
          'Lato',
          'Helvetica',
          'Times-Roman',
          'Courier',
          'Roboto',
          'SourceSansPro',
        ],
        sectionPositioning: false,
        enableDnd: false,
        heading: 'Academic cv template',
        altText: 'Instaresume Resume Template: Multi column resume template',
      },
      {
        colors: ['#fdf3ef', '#E6FBE2', '#F6F2FF', '#ACE3DC', '#FFF6F1'],
        accessor: 'LightResume',
        key: 'light',
        name: 'Day',
        templateDescription:
          'Encompassing template highlighting strengths and work experience, suitable for various industries—a functional resume that universally excels.',
        category: [],
        previewUrl: {
          default: '/template-preview/200kb/LightPreview_200kb.png',
          lowRes: '/template-preview/30kb/LightPreview_30kb.webp',
          highRes: '/template-preview/100kb/LightPreview_100kb.png',
        },
        enableCustomFont: false,
        fonts: [
          'Default',
          'Lato',
          'Helvetica',
          'Times-Roman',
          'Courier',
          'Roboto',
          'SourceSansPro',
        ],
        sectionPositioning: false,
        enableDnd: false,
        heading: 'Creative CV Template',
        altText: 'Instaresume Resume Template: Creative CV Template',
      },
      {
        colors: ['#282522', '#1C413C', '#493655', '#0f141e', '#562E42'],
        accessor: 'TwilightResume',
        key: 'twilight',
        name: 'Night',
        templateDescription:
          "Standing out is challenging, but this contemporary resume template ensures you won't go unnoticed in a crowd.",
        category: [],
        previewUrl: {
          default: '/template-preview/200kb/TwilightPreview_200kb.png',
          lowRes: '/template-preview/30kb/TwilightPreview_30kb.webp',
          highRes: '/template-preview/100kb/TwilightPreview_100kb.png',
        },
        enableCustomFont: false,
        fonts: [
          'Default',
          'Lato',
          'Helvetica',
          'Times-Roman',
          'Courier',
          'Roboto',
          'SourceSansPro',
        ],
        sectionPositioning: false,
        enableDnd: false,
        hideExpertiseLevel: true,
        heading: 'Black and white resume template',
        altText: 'Instaresume Resume Template: Black and white resume template',
      },
      {
        colors: ['#ff0000', '#ED6F00', '#000000', '#4A62FF', '#009700'],
        accessor: 'AtsBasicResume',
        key: 'universe',
        name: 'Universe',
        templateDescription:
          'Simple resume layout for conservative industries, which is a minimalistic upgrade from the traditional resumes.',
        category: [],
        previewUrl: {
          default: '/template-preview/200kb/AtsBasicPreview_200kb.png',
          lowRes: '/template-preview/30kb/AtsBasicPreview_30kb.webp',
          highRes: '/template-preview/100kb/AtsBasicPreview_100kb.png',
        },
        enableCustomFont: true,
        fonts: ['Lato', 'Helvetica', 'Times-Roman', 'Courier'],
        defaultFont: 'Helvetica',
        sectionPositioning: false,
        enableDnd: false,
        heading: 'Professional resume template',
        altText: 'Instaresume Resume Template: Professional resume template',
      },
      {
        colors: [
          '#505050',
          '#7C6879',
          '#518071',
          '#009700',
          '#ED6F00',
          '#000000',
        ],
        accessor: 'Marshmallow',
        key: 'dawn',
        name: 'Dawn',
        templateDescription:
          'A skill-based resume created especially for the job-seekers that are pursuing a career change or are recent graduates.',
        category: [],
        previewUrl: {
          default: '/template-preview/200kb/MarshmallowPreview_200kb.png',
          lowRes: '/template-preview/30kb/MarshmallowPreview_30kb.webp',
          highRes: '/template-preview/100kb/MarshmallowPreview_100kb.png',
        },
        enableCustomFont: false,
        fonts: [
          'Default',
          'Lato',
          'Helvetica',
          'Times-Roman',
          'Courier',
          'Roboto',
          'SourceSansPro',
        ],
        sectionPositioning: false,
        enableDnd: true,
        heading: 'Business resume template',
        altText: 'Instaresume Resume Template: Business resume template',
      },
      {
        colors: ['#313C4E', '#4D516A', '#4E353B', '#5e6579', '#424447'],
        accessor: 'ClientAdvanceResume',
        key: 'everest',
        name: 'Everest',
        templateDescription:
          'A professional resume template that has been approved by various recruiters and helped many experienced professionals to get their dream job.',
        category: [],
        previewUrl: {
          default: '/template-preview/200kb/TokyoPreview_200kb.png',
          lowRes: '/template-preview/30kb/TokyoPreview_30kb.webp',
          highRes: '/template-preview/100kb/TokyoPreview_100kb.png',
        },
        enableCustomFont: false,
        fonts: [
          'Default',
          'Lato',
          'Helvetica',
          'Times-Roman',
          'Courier',
          'Roboto',
          'SourceSansPro',
        ],
        sectionPositioning: true,
        enableDnd: true,
        defaultSectionPosition: {
          courses: 'left',
          workExperiences: 'left',
          educations: 'left',
          skills: 'right',
          internships: 'left',
          activities: 'left',
          hobbies: 'right',
          languages: 'right',
          references: 'right',
          links: 'right',
          customSections: 'left',
        },
        hideExpertiseLevel: true,
        heading: 'Combined resume template',
        altText: 'Instaresume Resume Template: Combined resume template',
      },
      {
        colors: ['#000000', '#F4870B', '#ff0000', '#e80865', '#2C7865'],
        accessor: 'California',
        key: 'california',
        name: 'River',
        templateDescription:
          'Write a bulleted or paragraph description of your experience, abilities, and results, starting with your most recent employment.',
        category: [],
        previewUrl: {
          default: '/template-preview/200kb/CaliforniaPreview_200kb.webp',
          lowRes: '/template-preview/30kb/CaliforniaPreview_30kb.webp',
          highRes: '/template-preview/100kb/CaliforniaPreview_100kb.webp',
        },
        enableCustomFont: true,
        fonts: ['Helvetica', 'Times-Roman', 'Courier', 'Lato'],
        defaultFont: 'Times-Roman',
        sectionPositioning: false,
        enableDnd: true,
        hideExpertiseLevel: true,
        skillDescription: true,
        heading: 'Harvard resume template',
      },
    ],
  },
};

export const getPartnerConfig = (partnerId) => {
  const partnerConfig = partners[partnerId];
  if (!partnerConfig) {
    throw new Error(`Partner configuration for ${partnerId} not found`);
  }
  return partnerConfig;
};

export default partners;
